module.exports = __webpack_public_path__ + "static/panda-bbca108b00cdbfed39292d419631c696.svg";